import React from 'react'
import PropTypes from 'prop-types'
// import get from 'lodash.get'
import RingChart from '../../../charts/echarts/RingChart'
// import { planning } from '../../../../api/integrations'
import ChartProvider from '../../../charts/echarts/ChartProvider'

function MetricRing ({
  chartData,
  chartOptions,
  seriesId,
  ...seriesProps
}) {
  // const { data, isLoading } = planning.usePlanningQuery({ queryType, payload })

  // const chartData = useMemo(() => {
  //   if (!Object.keys(data ?? {}).length) return []
  //
  //   return metrics.map((metric) => {
  //     const value = get(data, metric.accessor)
  //     const pV = metric.target ? (value * 100.0) / metric.target : (value * 100.0)
  //
  //     return {
  //       value: pV * 100,
  //       name: metric.name || ''
  //     }
  //   })
  // }, [data, metrics])

  return (
    <ChartProvider {...chartOptions}>
      <RingChart
        seriesId={seriesId}
        data={chartData}
        {...seriesProps}
      />
    </ChartProvider>
  )
}

MetricRing.propTypes = {
  queryType: PropTypes.string,
  payload: PropTypes.object,
  chartData: PropTypes.array,
  chartOptions: PropTypes.object,
  seriesId: PropTypes.string
}

MetricRing.defaultProps = {
  chartOptions: {
    height: 500,
    width: 500
  },
  height: 500,
  width: 500
}

export default MetricRing
